import { ActionType, RootAction } from '@/actions/actiontypes';
import { Config } from '@/bootstrap/config';

export const configReducer = (state: Config, action: RootAction) => {
    if (action.type === ActionType.BOOTSTRAP) return action.bootstrappedState.config;
    else if (action.type === ActionType.CONFIG_UPDATE)
        return { ...state, [action.key]: action.value };
    else return state;
};
